import { useQueryNotifications } from 'lib/useQueryNotifications';
import useSocketJSClient from 'lib/useSocketJSClient';
import { createContext, useContext, useState } from 'react';
import { IHasChildren, INotification } from 'types';
import { useInitProvider } from './InitProvider';
import { errorGenerator } from 'lib/errorGenerator';
import { generatoreCode } from 'lib/generateCode';

const NotificationsContext = createContext({
  openSocket: () => { },
  closeSocket: () => { },
  sendMessage: (data: INotification) => { },
  socket: {},
  notifications: null,
  counter: 0,
  refetch: () => { }
});

// const fakeNotifications = [
//   {
//     "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//     "notificationId": "LSFjtkstURge",
//     "appCode": "requirosign",
//     "appVersion": "v1",
//     "content": "Accedi a Requiro Sign per firmare il documento. Accedi a Requiro Sign per firmare il documento. Accedi a Requiro Sign per firmare il documento. https://rqxusso.archivagroup.it/auth/realms/standard/protocol/openid-connect/auth?response_type=code&client_id=portal-backend&redirect_uri=https%3A%2F%2Frqxuat.archivagroup.it%2F&state=26504efe-520f-431e-b799-b6048a8efa44&login=true&scope=openid#requirosign",
//     "title": "Documento pronto",
//     "date": "2024-07-03T09:56:58.924788Z",
//     "state": 1,
//     "time": "8 mesi fa",
//     "url": "https://rqxuat.archivagroup.it#requirosign"
//   },
//   {
//     "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//     "notificationId": "LSFjtkstURge",
//     "appCode": "requirosign",
//     "appVersion": "v1",
//     "content": "Accedi a Requiro Sign per firmare il documento",
//     "title": "Documento pronto",
//     "date": "2024-07-03T09:56:58.924788Z",
//     "state": 0,
//     "time": "8 mesi fa",
//     "url": "https://rqxuat.archivagroup.it#requirosign"
//   },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 0,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 0,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 1,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 1,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 0,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 0,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 1,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 0,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 1,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// },
// {
//   "userId": "e35c116b-7fa3-4924-8ced-f6634a89e05e",
//   "notificationId": "LSFjtkstURge",
//   "appCode": "requirosign",
//   "appVersion": "v1",
//   "content": "Accedi a Requiro Sign per firmare il documento",
//   "title": "Documento pronto",
//   "date": "2024-07-03T09:56:58.924788Z",
//   "state": 0,
//   "time": "8 mesi fa",
//   "url": "https://rqxuat.archivagroup.it#requirosign"
// }
// ]

const fakeNotifications = []

const notificationState = {
  read: 1,
  toRead: 0,
  deleted: -1,
};

const NotificationsProvider = ({ children }: IHasChildren) => {
  const { dump } = useInitProvider();
  // list of notifications
  const [notifications, setNotifications] = useState<INotification[] | null>(
    fakeNotifications as any,
  );
  // number of notifications
  const [counter, setCounter] = useState<number>(fakeNotifications.filter(
    (item) => item.state === notificationState.toRead,
  ).length);

  // query, with options
  const queryNotificationsInfo = useQueryNotifications({
    retry: false,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      const notifications = data?.data?.data;
      // console.log(`Notification provider got notifications ${notifications}`);
      setNotifications(notifications);
      notifications &&
        setCounter(
          notifications.filter(
            (item) => item.state === notificationState.toRead,
          ).length,
        );
    },
    onError: (error) => {
      console.log('useQueryNotifications onError ->', { error });
      const errorCode = generatoreCode(8);
      errorGenerator(
        errorCode,
        error,
        'apiError useQueryNotifications',
        'apiError useQueryNotifications',
      );
      // use fake data for testing pourpose
      // ------------------
      setNotifications(fakeNotifications as any);
      setCounter(
        fakeNotifications.filter(
          (item) => item.state === notificationState.toRead,
        ).length,
      );
      // manage error with real data
      // ------------------
      // setNotifications([]);
      // setCounter(0);
    },
    onSettled: (data, error) => {
      // console.log('useQueryNotifications onSettled ->', data, error);
      // open socket connection
      socketClient.openSocket();
    },
  });

  const onNewNotification = (newNotification) => {
    console.log(`onNewNotification ${JSON.stringify(newNotification)}`);

    queryNotificationsInfo.refetch();
    // const n = notifications || [];

    // // 1) non ho notifiche?
    // if (isNil(notifications) || isEmpty(notifications)) {
    //   console.log('------------- 1 ---------------');
    //   setNotifications([newNotification]);
    // }
    // // 2) è una nuova notifica?
    // const ids = notifications.map((item: INotification) => item.notificationId);

    // if (!ids.includes(newNotification.notificationId)) {
    //   console.log('------------- 2 ---------------');
    //   setNotifications([newNotification, ...notifications]);
    // } else {
    //   console.log('------------- 3 ---------------');
    //   // 3) è una notifica che è stata modificata?
    //   const updatedNotifications = notifications.reduce(
    //     (prev: INotification[] | [], curr: INotification) => {
    //       return curr.notificationId === newNotification.notificationId
    //         ? [...prev, newNotification]
    //         : [...prev, curr];
    //     },
    //     [],
    //   );
    //   setNotifications(updatedNotifications);
    // }
  };

  // websocket client
  const socketClient = useSocketJSClient(onNewNotification);

  // web socket message dispatcher
  const sendMessage = (data: INotification) => {
    // const unique = generatoreCode(12);
    console.log(`Send websocket ${JSON.stringify(data)}`)
    const { notificationId } = data;
    const { sendChannel, token } = dump.shell?.ws;
    const { socket } = socketClient;
    const stringMsg = JSON.stringify({ notificationId, operation: 'read' });
    const uri = `${sendChannel}/${token}`
    console.log(`Send websocket "${uri}" ${stringMsg}`)
    socket['send'](`${uri}`, {}, stringMsg);
  };

  const contextValue = {
    ...socketClient,
    notifications /* : fakeNotifications */,
    counter,
    sendMessage,
    refetch: queryNotificationsInfo.refetch as any
  };
  return (
    <NotificationsContext.Provider value={contextValue}>
      {children}
    </NotificationsContext.Provider>
  );
};

export function useNotificationsContext() {
  const ctx = useContext(NotificationsContext);
  if (!ctx) throw new Error('context cannot be undefined');
  return ctx;
}

export default NotificationsProvider;
